import get from 'lodash/get';
import pick from 'lodash/pick';

const STORAGE_KEY = 'mx';
export const loadState = function loadState(storage = localStorage) {
  try {
    const serializedState = storage.getItem(STORAGE_KEY);
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = function saveState(state, storage = localStorage) {
  try {
    // WARNING: DO NOT STORE PROTECTED HEALTH INFORMATION (PHI) IN LOCAL STORAGE!!!
    // BY LAW PHI MUST BE ENCRYPTED AT REST
    const serializedState = JSON.stringify({
      auth: pick(
        state.auth,
        'user',
        'email',
        'accessToken',
        'refreshToken',
        'deviceToken',
        'deviceExp',
        'deviceEmail',
        'impersonationEmail',
        'impersonationUser',
        'impersonationToken',
        'impersonationRefreshToken',
      ),
      leadTable: state.leadTable,
      sessionTable: state.sessionTable,
      inactivity: get(state, 'inactivity', {}),
      calendarSettings: state.calendarSettings,
      patientSignup: pick(
        state.patientSignup,
        'screenIndex',
        'complete',
        'hasGuardian',
        'providerId',
        'sessionTypeId',
        'date',
        'time',
      ),
      providers: pick(
        state.providers,
        'providerFilters',
      ),
      newAppointmentForm: state.newAppointmentForm,
      menu: state.menu,
      stagingGateway: state?.stagingGateway,
    });
    storage.setItem(STORAGE_KEY, serializedState);
  } catch (err) {

  }
};
